import { render, staticRenderFns } from "./right-second-content.vue?vue&type=template&id=80c88b34&scoped=true&"
import script from "./right-second-content.vue?vue&type=script&lang=js&"
export * from "./right-second-content.vue?vue&type=script&lang=js&"
import style0 from "./right-second-content.vue?vue&type=style&index=0&id=80c88b34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c88b34",
  null
  
)

export default component.exports